( function() {
	'use strict';
	document.addEventListener( 'DOMContentLoaded', function() {
		var containers = document.querySelectorAll( '.wp-block-post-content.is-collapsible-post-content' );

		if ( !containers.length ) {
			return;
		}

		containers.forEach( function( container ) {
			var links = container.querySelectorAll('.wp-block-post-excerpt__more-link');
			links.forEach(function(link) {
				link.addEventListener('click', function() {
					container.classList.toggle( 'is-collapsed' );

					/**
					 * once clicked, the [more] element will disappear
					 */
					link.innerHTML = container.classList.contains('is-collapsed')
						? 'More <i class="arrow-down"/>'
						: '';
				});
			});
		} );
	} );
} )();
